import { clarify } from '@/domain/services/VueDataProvider';
import Uploader from '@/lib/uploader.js';

export default function () {
	// Setup the Uploader, if included on the page.
	if ($('#uploader').length > 0) {
		new Uploader(clarify(uploaderOptions));
	}
}
